export default{

    checkphone:function(phone){//验证手机号
        if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))){ 
            return false; 
        }else{
            return true;
        }
    },

    handleNumber:function(num){
        console.log(num.toLocaleString());
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // if(num<10000){
        //     return num
        // }else{
        //     let frist_init = num.toString().slice(0,num.length - 4);//取四位之外的数值
        //     let last_four = num.toString().substr(num.length - 4);//取后四位
        //     return (frist_init * 1 + (last_four * 1 / 10000)).toFixed(2) + "w"
        // }
    },
    
    changedate:function(value){//时间戳转为日期
        //return new Date(timestamp).toLocaleString();
        
        // var date = new Date(value);
        // var YY = date.getFullYear() + '-';
        // var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        // var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        // var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        // var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        // var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        // return YY + MM + DD + " " + hh + mm + ss;

        if (value == null) {
            return "";
        }
        const date = new Date(value);
        // 提取 UTC 时间组件
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth() + 1;
        const utcDay = date.getUTCDate();
        const utcHours = date.getUTCHours();
        const utcMinutes = date.getUTCMinutes();
        const utcSeconds = date.getUTCSeconds();

        // 手动调整为印尼时区 UTC+7
        let hours = utcHours + 8;
        let day = utcDay;

        // 处理小时溢出（如 UTC 时间 18:00 → UTC+7 为次日 01:00）
        if (hours >= 24) {
            hours -= 24;
            day += 1;
        }

        // 补零并格式化
        const format = (n) => String(n).padStart(2, '0');
        const formattedTime = `${utcYear}-${format(utcMonth)}-${format(day)} ` + 
        `${format(hours)}:${format(utcMinutes)}:${format(utcSeconds)}`;

        return formattedTime;
    }
}
 